<div class="row explore-section">
<div class="col-md-4 uil-card-shadow card-padding" *ngFor="let data of LinkCardArr">
  <div class="uil-card-span-12 uil-clickable uil-black-card height_adjust uil-card-default exploreMore" (click)="linkCardClicked(data)">
    <div class="uil-card-title-area">
      <div class="uil-card-title card-title">{{data.Title_Name}}</div>
    </div>
    <div class="uil-card-text uil-dls-font-caption-02 card-description card-label">
      {{data.Title_Description}}
    </div>
    <div class="uil-card-footer">
      <div class="uil-card-footer-icon-area">
        <div class="uil-icon-Arrow-right-up"></div>
      </div>
    </div>
  </div>
</div>
</div>